import { VariableType } from 'json-to-graphql-query';

import { Resource } from './resource';

export class LockResource extends Resource {
  /**
   * Zwraca blokadę dokumentu
   *
   * @param {*} variables
   * @returns {Promise<any>}
   * @memberof LockResource
   */
  public lockFind(variables: any): Promise<any> {
    const query = this.prepareOptions({
      query: {
        __variables: { documentId: 'Int!' },
        lockFind: {
          __args: { documentId: new VariableType('documentId') },
          id: true,
          userLogin: true
        }
      }
    });

    return this.query({ query, variables }, 'lockFind');
  }
}

export const lockResource = new LockResource();
